//
//  SDKBlurType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var BlurType;
(function (BlurType) {
    BlurType["layer"] = "Layer";
    BlurType["background"] = "Background";
})(BlurType || (BlurType = {}));
